import { gql, useQuery } from '@apollo/client'
import { currentMarketIdVar } from 'graphql/reactive'

import fullPublicVideoRequestDescriptionSuggestion from '../graphql/fragments/fullPublicVideoRequestDescriptionSuggestion'

export const GET_VIDEO_REQ_DESC_SUGGESTIONS_QUERY = gql`
  query GetVideoRequestDescriptions(
    $marketId: ID!
    $profileId: ID!
    $productId: ID
  ) {
    market(id: $marketId) {
      id
      videoRequestDescriptionSuggestions(
        profileId: $profileId
        productId: $productId
      ) {
        ...fullPublicVideoRequestDescriptionSuggestion
      }
    }
  }
  ${fullPublicVideoRequestDescriptionSuggestion}
`

export default function useVideoRequestDescriptionSuggestions({
  profileId,
  productId,
}) {
  const marketId = currentMarketIdVar()

  const { loading, data = {}, error } = useQuery(
    GET_VIDEO_REQ_DESC_SUGGESTIONS_QUERY,
    {
      variables: { profileId, marketId, productId },
    },
  )

  const videoRequestDescriptionSuggestions =
    data.market && data.market.videoRequestDescriptionSuggestions

  return { videoRequestDescriptionSuggestions, loading, error }
}
